<template>
  <div>
    <slot name="header"></slot>    
    <div class="form-check">
    <input class="form-check-input" type="checkbox" value="" :id="name" @change="onChange(name, $event)" v-model="checked">
    <label class="form-check-label" :for="name">
      <slot name="label"></slot>
    </label>
  </div>
  </div>
</template>

<script>
export default {
  props: { 
    name: { type: String, required: true },
    defaultChecked: { type: Boolean, required: false, default: true }
  },
  data() {
    return {
      checked: this.defaultChecked
    }
  },
  created() {
    // reset checkbox to initial state when all filtes are reset
    EventDispatcher.listen('resetFilters', () => {
      this.checked = this.defaultChecked;
    });
  },
  methods: {
    onChange(name, event) {
      this.checked != this.checked;
      EventDispatcher.fire('checkBoxUpdated', event);
    }
  }
}
</script>

<style lang="scss" scoped>
.form-check-input {
  position:relative;
  width:1rem;
  height:1rem;
}
h4 {
  color: #333;
  font-size: 0.875rem;
  border-bottom: 1px dotted #333;
  padding-bottom:.25rem;
  margin-bottom:.4rem;
  margin-top:1.5rem;
}

div.form-check {
  white-space: nowrap;
  font-size:1rem;
  label {
    color: #333;
    vertical-align: top;
    padding-top:.025rem;
    white-space: normal;
    img {
      margin-top: -.25rem;
      width: .75rem;
    }
  }
}

@media (min-width:992px) {
  div.form-check {
    font-size:1.125rem;
  }
}

@media (max-width:769px) {
  .form-check-label span {
    display:none;
  }
}
</style>